import React, { useEffect } from 'react';
import { ConfigProvider } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import zhCN from 'antd/es/locale/zh_CN';
import 'antd/dist/antd.min.css';
import './App.less';
import { useRoutes } from 'react-router-dom';
import RoutesList from './routes';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Cookies from 'js-cookie';
import { getCookie, getQueryString } from './utils/utils';

dayjs.locale('zh-cn');

function App() {
    const element = useRoutes(RoutesList);
    const [searchParams] = useSearchParams();
    if (searchParams.get('returnurl')) {
        window.location.href = searchParams.get('returnurl') || '';
    }

    if (typeof (window as any).wx !== 'undefined' && (window as any).wx.miniProgram) {
        (window as any).wx.miniProgram.getEnv(function (res: any) {
            if (res.miniprogram) {
                // 小程序跳转当前项目 - 添加memcard、token
                if (searchParams.get('memcard') && searchParams.get('token')) {
                    Cookies.set('authentication_member_card', searchParams.get('memcard') || '', { domain: '.cn-healthcare.com' });
                    Cookies.set('memToken', searchParams.get('token') || '', { domain: '.cn-healthcare.com' });
                } else {
                    // 小程序webview跳转携带open=miniprogram - 则表示当前页面来源于小程序跳转 - 同步小程序登录状态
                    if (searchParams.get('open') === 'miniprogram') {
                        Cookies.remove('authentication_member_card', { domain: '.cn-healthcare.com' });
                        Cookies.remove('memToken', { domain: '.cn-healthcare.com' });
                    }
                }
            }
        });
    }

    // 健学云跳转携带登录token
    if (getQueryString('memToken')) {
        Cookies.set('memToken', getQueryString('memToken') || '', { domain: '.cn-healthcare.com' });
    }
    // 健学云跳转携带memCard
    if (getQueryString('memCard')) {
        Cookies.set('authentication_member_card', getQueryString('memCard') || '', { domain: '.cn-healthcare.com' });
    }

    // 自适应适配pc、移动端
    const initFontSize = () => {
        let designSize = window.innerWidth > 750 ? 1920 : 750; // 设计图尺寸
        let html = document.documentElement;
        let wW = html.clientWidth; // 窗口宽度
        let rem = (wW * 100) / designSize;

        if (window.innerWidth > 750 && window.innerWidth <= 2560) {
            document.documentElement.style.fontSize = rem + 'px';
        } else {
            document.documentElement.style.fontSize = 100 + 'px';
        }
    };

    useEffect(() => {
        initFontSize();
    }, []);

    return (
        <ConfigProvider locale={zhCN}>
            <div className="App">{element}</div>
        </ConfigProvider>
    );
}

export default App;
